(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(require('@angular/core'),require('@angular/common'),require('primeng/button'),require('primeng/api'),require('primeng/inputtext'),exports, require('@angular/core'), require('@angular/common'), require('@angular/animations'), require('primeng/inputtext'), require('primeng/button'), require('primeng/api'), require('primeng/dom'), require('primeng/utils'), require('@angular/forms')) :
  typeof define === 'function' && define.amd ? define('primeng/autocomplete', ['@angular/core','@angular/common','primeng/button','primeng/api','primeng/inputtext','exports', '@angular/core', '@angular/common', '@angular/animations', 'primeng/inputtext', 'primeng/button', 'primeng/api', 'primeng/dom', 'primeng/utils', '@angular/forms'], factory) :
  (global = global || self, factory(global.ng.core,global.ng.common,global.primeng.button,global.primeng.api,global.primeng.inputtext,(global.primeng = global.primeng || {}, global.primeng.autocomplete = {}), global.ng.core, global.ng.common, global.ng.animations, global.primeng.inputtext, global.primeng.button, global.primeng.api, global.primeng.dom, global.primeng.utils, global.ng.forms));
}(this, (function (ɵngcc0,ɵngcc1,ɵngcc2,ɵngcc3,ɵngcc4,exports, core, common, animations, inputtext, button, api, dom, utils, forms) { 
var _c0 = ["in"];
var _c1 = ["multiIn"];
var _c2 = ["multiContainer"];
var _c3 = ["ddBtn"];
function AutoComplete_input_1_Template(rf, ctx) { if (rf & 1) {
    var _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "input", 6, 7);
    ɵngcc0.ɵɵlistener("click", function AutoComplete_input_1_Template_input_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); var ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.onInputClick($event); })("input", function AutoComplete_input_1_Template_input_input_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); var ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.onInput($event); })("keydown", function AutoComplete_input_1_Template_input_keydown_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); var ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.onKeydown($event); })("keyup", function AutoComplete_input_1_Template_input_keyup_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); var ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.onKeyup($event); })("focus", function AutoComplete_input_1_Template_input_focus_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); var ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.onInputFocus($event); })("blur", function AutoComplete_input_1_Template_input_blur_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); var ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.onInputBlur($event); })("change", function AutoComplete_input_1_Template_input_change_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); var ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.onInputChange($event); })("paste", function AutoComplete_input_1_Template_input_paste_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); var ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.onInputPaste($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMap(ctx_r0.inputStyleClass);
    ɵngcc0.ɵɵproperty("ngStyle", ctx_r0.inputStyle)("autocomplete", ctx_r0.autocomplete)("ngClass", "ui-inputtext ui-widget ui-state-default ui-corner-all ui-autocomplete-input")("value", ctx_r0.inputFieldValue)("readonly", ctx_r0.readonly)("disabled", ctx_r0.disabled);
    ɵngcc0.ɵɵattribute("type", ctx_r0.type)("id", ctx_r0.inputId)("required", ctx_r0.required)("name", ctx_r0.name)("aria-controls", ctx_r0.listId)("aria-expanded", ctx_r0.overlayVisible)("aria-activedescendant", "p-highlighted-option")("autofocus", ctx_r0.autofocus)("placeholder", ctx_r0.placeholder)("size", ctx_r0.size)("maxlength", ctx_r0.maxlength)("tabindex", ctx_r0.tabindex)("aria-label", ctx_r0.ariaLabel)("aria-labelledby", ctx_r0.ariaLabelledBy)("aria-required", ctx_r0.required);
} }
function AutoComplete_ul_2_li_2_span_2_Template(rf, ctx) { if (rf & 1) {
    var _r24 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 19);
    ɵngcc0.ɵɵlistener("click", function AutoComplete_ul_2_li_2_span_2_Template_span_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r24); ɵngcc0.ɵɵnextContext(); var _r19 = ɵngcc0.ɵɵreference(1); var ctx_r23 = ɵngcc0.ɵɵnextContext(2); return ctx_r23.removeItem(_r19); });
    ɵngcc0.ɵɵelementEnd();
} }
function AutoComplete_ul_2_li_2_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 20);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var val_r18 = ɵngcc0.ɵɵnextContext().$implicit;
    var ctx_r21 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r21.resolveFieldData(val_r18));
} }
function AutoComplete_ul_2_li_2_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
var _c4 = function (a0) { return { $implicit: a0 }; };
function AutoComplete_ul_2_li_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 14, 15);
    ɵngcc0.ɵɵtemplate(2, AutoComplete_ul_2_li_2_span_2_Template, 1, 0, "span", 16);
    ɵngcc0.ɵɵtemplate(3, AutoComplete_ul_2_li_2_span_3_Template, 2, 1, "span", 17);
    ɵngcc0.ɵɵtemplate(4, AutoComplete_ul_2_li_2_ng_container_4_Template, 1, 0, "ng-container", 18);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var val_r18 = ctx.$implicit;
    var ctx_r16 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r16.disabled);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r16.selectedItemTemplate);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r16.selectedItemTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(4, _c4, val_r18));
} }
var _c5 = function (a0, a1) { return { "ui-state-disabled": a0, "ui-state-focus": a1 }; };
function AutoComplete_ul_2_Template(rf, ctx) { if (rf & 1) {
    var _r27 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ul", 8, 9);
    ɵngcc0.ɵɵlistener("click", function AutoComplete_ul_2_Template_ul_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r27); var _r17 = ɵngcc0.ɵɵreference(5); return _r17.focus(); });
    ɵngcc0.ɵɵtemplate(2, AutoComplete_ul_2_li_2_Template, 5, 6, "li", 10);
    ɵngcc0.ɵɵelementStart(3, "li", 11);
    ɵngcc0.ɵɵelementStart(4, "input", 12, 13);
    ɵngcc0.ɵɵlistener("input", function AutoComplete_ul_2_Template_input_input_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r27); var ctx_r28 = ɵngcc0.ɵɵnextContext(); return ctx_r28.onInput($event); })("click", function AutoComplete_ul_2_Template_input_click_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r27); var ctx_r29 = ɵngcc0.ɵɵnextContext(); return ctx_r29.onInputClick($event); })("keydown", function AutoComplete_ul_2_Template_input_keydown_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r27); var ctx_r30 = ɵngcc0.ɵɵnextContext(); return ctx_r30.onKeydown($event); })("keyup", function AutoComplete_ul_2_Template_input_keyup_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r27); var ctx_r31 = ɵngcc0.ɵɵnextContext(); return ctx_r31.onKeyup($event); })("focus", function AutoComplete_ul_2_Template_input_focus_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r27); var ctx_r32 = ɵngcc0.ɵɵnextContext(); return ctx_r32.onInputFocus($event); })("blur", function AutoComplete_ul_2_Template_input_blur_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r27); var ctx_r33 = ɵngcc0.ɵɵnextContext(); return ctx_r33.onInputBlur($event); })("change", function AutoComplete_ul_2_Template_input_change_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r27); var ctx_r34 = ɵngcc0.ɵɵnextContext(); return ctx_r34.onInputChange($event); })("paste", function AutoComplete_ul_2_Template_input_paste_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r27); var ctx_r35 = ɵngcc0.ɵɵnextContext(); return ctx_r35.onInputPaste($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(20, _c5, ctx_r1.disabled, ctx_r1.focus));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.value);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵclassMap(ctx_r1.inputStyleClass);
    ɵngcc0.ɵɵproperty("disabled", ctx_r1.disabled)("readonly", ctx_r1.readonly)("autocomplete", ctx_r1.autocomplete)("ngStyle", ctx_r1.inputStyle);
    ɵngcc0.ɵɵattribute("type", ctx_r1.type)("id", ctx_r1.inputId)("placeholder", ctx_r1.value && ctx_r1.value.length ? null : ctx_r1.placeholder)("tabindex", ctx_r1.tabindex)("maxlength", ctx_r1.maxlength)("autofocus", ctx_r1.autofocus)("aria-label", ctx_r1.ariaLabel)("aria-labelledby", ctx_r1.ariaLabelledBy)("aria-required", ctx_r1.required)("aria-controls", ctx_r1.listId)("aria-expanded", ctx_r1.overlayVisible)("aria-activedescendant", "p-highlighted-option");
} }
function AutoComplete_i_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 21);
} }
function AutoComplete_button_4_Template(rf, ctx) { if (rf & 1) {
    var _r38 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 22, 23);
    ɵngcc0.ɵɵlistener("click", function AutoComplete_button_4_Template_button_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r38); var ctx_r37 = ɵngcc0.ɵɵnextContext(); return ctx_r37.handleDropdownClick($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("icon", ctx_r3.dropdownIcon)("disabled", ctx_r3.disabled);
    ɵngcc0.ɵɵattribute("tabindex", ctx_r3.tabindex);
} }
function AutoComplete_div_5_li_3_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var option_r42 = ɵngcc0.ɵɵnextContext().$implicit;
    var ctx_r44 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r44.resolveFieldData(option_r42));
} }
function AutoComplete_div_5_li_3_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
var _c6 = function (a1) { return { "ui-autocomplete-list-item ui-corner-all": true, "ui-state-highlight": a1 }; };
var _c7 = function (a0, a1) { return { $implicit: a0, index: a1 }; };
function AutoComplete_div_5_li_3_Template(rf, ctx) { if (rf & 1) {
    var _r48 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 28);
    ɵngcc0.ɵɵlistener("mouseenter", function AutoComplete_div_5_li_3_Template_li_mouseenter_0_listener() { var restoredCtx = ɵngcc0.ɵɵrestoreView(_r48); var option_r42 = restoredCtx.$implicit; var ctx_r47 = ɵngcc0.ɵɵnextContext(2); return ctx_r47.highlightOption = option_r42; })("mouseleave", function AutoComplete_div_5_li_3_Template_li_mouseleave_0_listener() { ɵngcc0.ɵɵrestoreView(_r48); var ctx_r49 = ɵngcc0.ɵɵnextContext(2); return ctx_r49.highlightOption = null; })("click", function AutoComplete_div_5_li_3_Template_li_click_0_listener() { var restoredCtx = ɵngcc0.ɵɵrestoreView(_r48); var option_r42 = restoredCtx.$implicit; var ctx_r50 = ɵngcc0.ɵɵnextContext(2); return ctx_r50.selectItem(option_r42); });
    ɵngcc0.ɵɵtemplate(1, AutoComplete_div_5_li_3_span_1_Template, 2, 1, "span", 29);
    ɵngcc0.ɵɵtemplate(2, AutoComplete_div_5_li_3_ng_container_2_Template, 1, 0, "ng-container", 18);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var option_r42 = ctx.$implicit;
    var idx_r43 = ctx.index;
    var ctx_r40 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(5, _c6, ctx_r40.highlightOption == option_r42))("id", ctx_r40.highlightOption == option_r42 ? "p-highlighted-option" : "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r40.itemTemplate);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r40.itemTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(7, _c7, option_r42, idx_r43));
} }
function AutoComplete_div_5_li_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 30);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r41 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r41.emptyMessage);
} }
var _c8 = "ui-autocomplete-panel ui-widget ui-widget-content ui-corner-all ui-shadow";
var _c9 = function () { return [_c8]; };
var _c10 = function (a0, a1) { return { showTransitionParams: a0, hideTransitionParams: a1 }; };
var _c11 = function (a1) { return { value: "visible", params: a1 }; };
function AutoComplete_div_5_Template(rf, ctx) { if (rf & 1) {
    var _r52 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 0, 24);
    ɵngcc0.ɵɵlistener("@overlayAnimation.start", function AutoComplete_div_5_Template_div_animation_overlayAnimation_start_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r52); var ctx_r51 = ɵngcc0.ɵɵnextContext(); return ctx_r51.onOverlayAnimationStart($event); })("@overlayAnimation.done", function AutoComplete_div_5_Template_div_animation_overlayAnimation_done_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r52); var ctx_r53 = ɵngcc0.ɵɵnextContext(); return ctx_r53.onOverlayAnimationDone($event); });
    ɵngcc0.ɵɵelementStart(2, "ul", 25);
    ɵngcc0.ɵɵtemplate(3, AutoComplete_div_5_li_3_Template, 3, 10, "li", 26);
    ɵngcc0.ɵɵtemplate(4, AutoComplete_div_5_li_4_Template, 2, 1, "li", 27);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMap(ctx_r4.panelStyleClass);
    ɵngcc0.ɵɵstyleProp("max-height", ctx_r4.scrollHeight);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction0(10, _c9))("ngStyle", ctx_r4.panelStyle)("@overlayAnimation", ɵngcc0.ɵɵpureFunction1(14, _c11, ɵngcc0.ɵɵpureFunction2(11, _c10, ctx_r4.showTransitionOptions, ctx_r4.hideTransitionOptions)));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵattribute("id", ctx_r4.listId);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r4.suggestions);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.noResults && ctx_r4.emptyMessage);
} }
var _c12 = function (a1, a2) { return { "ui-autocomplete ui-widget": true, "ui-autocomplete-dd": a1, "ui-autocomplete-multiple": a2 }; };
'use strict';

  var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
      var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
      if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
      else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
      return c > 3 && r && Object.defineProperty(target, key, r), r;
  };
  var __read = (this && this.__read) || function (o, n) {
      var m = typeof Symbol === "function" && o[Symbol.iterator];
      if (!m) return o;
      var i = m.call(o), r, ar = [], e;
      try {
          while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
      }
      catch (error) { e = { error: error }; }
      finally {
          try {
              if (r && !r.done && (m = i["return"])) m.call(i);
          }
          finally { if (e) throw e.error; }
      }
      return ar;
  };
  var __spread = (this && this.__spread) || function () {
      for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
      return ar;
  };
  var __values = (this && this.__values) || function(o) {
      var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
      if (m) return m.call(o);
      if (o && typeof o.length === "number") return {
          next: function () {
              if (o && i >= o.length) o = void 0;
              return { value: o && o[i++], done: !o };
          }
      };
      throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
  };
  var AUTOCOMPLETE_VALUE_ACCESSOR = {
      provide: forms.NG_VALUE_ACCESSOR,
      useExisting: core.forwardRef(function () { return AutoComplete; }),
      multi: true
  };
  var AutoComplete = /** @class */ (function () {
      function AutoComplete(el, renderer, cd, differs) {
          this.el = el;
          this.renderer = renderer;
          this.cd = cd;
          this.differs = differs;
          this.minLength = 1;
          this.delay = 300;
          this.type = 'text';
          this.autoZIndex = true;
          this.baseZIndex = 0;
          this.dropdownIcon = "pi pi-caret-down";
          this.unique = true;
          this.completeOnFocus = false;
          this.completeMethod = new core.EventEmitter();
          this.onSelect = new core.EventEmitter();
          this.onUnselect = new core.EventEmitter();
          this.onFocus = new core.EventEmitter();
          this.onBlur = new core.EventEmitter();
          this.onDropdownClick = new core.EventEmitter();
          this.onClear = new core.EventEmitter();
          this.onKeyUp = new core.EventEmitter();
          this.onShow = new core.EventEmitter();
          this.onHide = new core.EventEmitter();
          this.scrollHeight = '200px';
          this.dropdownMode = 'blank';
          this.showTransitionOptions = '225ms ease-out';
          this.hideTransitionOptions = '195ms ease-in';
          this.autocomplete = 'off';
          this.onModelChange = function () { };
          this.onModelTouched = function () { };
          this.overlayVisible = false;
          this.focus = false;
          this.inputFieldValue = null;
          this.differ = differs.find([]).create(null);
          this.listId = utils.UniqueComponentId() + '_list';
      }
      Object.defineProperty(AutoComplete.prototype, "suggestions", {
          get: function () {
              return this._suggestions;
          },
          set: function (val) {
              this._suggestions = val;
              this.handleSuggestionsChange();
          },
          enumerable: true,
          configurable: true
      });
      AutoComplete.prototype.ngAfterViewChecked = function () {
          var _this = this;
          //Use timeouts as since Angular 4.2, AfterViewChecked is broken and not called after panel is updated
          if (this.suggestionsUpdated && this.overlay && this.overlay.offsetParent) {
              setTimeout(function () {
                  if (_this.overlay) {
                      _this.alignOverlay();
                  }
              }, 1);
              this.suggestionsUpdated = false;
          }
          if (this.highlightOptionChanged) {
              setTimeout(function () {
                  if (_this.overlay) {
                      var listItem = dom.DomHandler.findSingle(_this.overlay, 'li.ui-state-highlight');
                      if (listItem) {
                          dom.DomHandler.scrollInView(_this.overlay, listItem);
                      }
                  }
              }, 1);
              this.highlightOptionChanged = false;
          }
      };
      AutoComplete.prototype.handleSuggestionsChange = function () {
          if (this._suggestions != null && this.loading) {
              this.highlightOption = null;
              if (this._suggestions.length) {
                  this.noResults = false;
                  this.show();
                  this.suggestionsUpdated = true;
                  if (this.autoHighlight) {
                      this.highlightOption = this._suggestions[0];
                  }
              }
              else {
                  this.noResults = true;
                  if (this.emptyMessage) {
                      this.show();
                      this.suggestionsUpdated = true;
                  }
                  else {
                      this.hide();
                  }
              }
              this.loading = false;
          }
      };
      AutoComplete.prototype.ngAfterContentInit = function () {
          var _this = this;
          this.templates.forEach(function (item) {
              switch (item.getType()) {
                  case 'item':
                      _this.itemTemplate = item.template;
                      break;
                  case 'selectedItem':
                      _this.selectedItemTemplate = item.template;
                      break;
                  default:
                      _this.itemTemplate = item.template;
                      break;
              }
          });
      };
      AutoComplete.prototype.writeValue = function (value) {
          this.value = value;
          this.filled = this.value && this.value != '';
          this.updateInputField();
      };
      AutoComplete.prototype.registerOnChange = function (fn) {
          this.onModelChange = fn;
      };
      AutoComplete.prototype.registerOnTouched = function (fn) {
          this.onModelTouched = fn;
      };
      AutoComplete.prototype.setDisabledState = function (val) {
          this.disabled = val;
      };
      AutoComplete.prototype.onInput = function (event) {
          var _this = this;
          // When an input element with a placeholder is clicked, the onInput event is invoked in IE.
          if (!this.inputKeyDown && dom.DomHandler.isIE()) {
              return;
          }
          if (this.timeout) {
              clearTimeout(this.timeout);
          }
          var value = event.target.value;
          if (!this.multiple && !this.forceSelection) {
              this.onModelChange(value);
          }
          if (value.length === 0 && !this.multiple) {
              this.hide();
              this.onClear.emit(event);
              this.onModelChange(value);
          }
          if (value.length >= this.minLength) {
              this.timeout = setTimeout(function () {
                  _this.search(event, value);
              }, this.delay);
          }
          else {
              this.suggestions = null;
              this.hide();
          }
          this.updateFilledState();
          this.inputKeyDown = false;
      };
      AutoComplete.prototype.onInputClick = function (event) {
          if (this.documentClickListener) {
              this.inputClick = true;
          }
      };
      AutoComplete.prototype.search = function (event, query) {
          //allow empty string but not undefined or null
          if (query === undefined || query === null || query === '') {
              return;
          }
          this.loading = true;
          this.completeMethod.emit({
              originalEvent: event,
              query: query
          });
      };
      AutoComplete.prototype.selectItem = function (option, focus) {
          if (focus === void 0) { focus = true; }
          if (this.forceSelectionUpdateModelTimeout) {
              clearTimeout(this.forceSelectionUpdateModelTimeout);
              this.forceSelectionUpdateModelTimeout = null;
          }
          if (this.multiple) {
              this.multiInputEL.nativeElement.value = '';
              this.value = this.value || [];
              if (!this.isSelected(option) || !this.unique) {
                  this.value = __spread(this.value, [option]);
                  this.onModelChange(this.value);
              }
          }
          else {
              this.inputEL.nativeElement.value = this.field ? utils.ObjectUtils.resolveFieldData(option, this.field) || '' : option;
              this.value = option;
              this.onModelChange(this.value);
          }
          this.onSelect.emit(option);
          this.updateFilledState();
          if (focus) {
              this.itemClicked = true;
              this.focusInput();
          }
      };
      AutoComplete.prototype.show = function () {
          if (this.multiInputEL || this.inputEL) {
              var hasFocus = this.multiple ? document.activeElement == this.multiInputEL.nativeElement : document.activeElement == this.inputEL.nativeElement;
              if (!this.overlayVisible && hasFocus) {
                  this.overlayVisible = true;
              }
          }
      };
      AutoComplete.prototype.onOverlayAnimationStart = function (event) {
          switch (event.toState) {
              case 'visible':
                  this.overlay = event.element;
                  this.appendOverlay();
                  if (this.autoZIndex) {
                      this.overlay.style.zIndex = String(this.baseZIndex + (++dom.DomHandler.zindex));
                  }
                  this.alignOverlay();
                  this.bindDocumentClickListener();
                  this.bindDocumentResizeListener();
                  this.onShow.emit(event);
                  break;
              case 'void':
                  this.onOverlayHide();
                  break;
          }
      };
      AutoComplete.prototype.onOverlayAnimationDone = function (event) {
          if (event.toState === 'void') {
              this._suggestions = null;
          }
      };
      AutoComplete.prototype.appendOverlay = function () {
          if (this.appendTo) {
              if (this.appendTo === 'body')
                  document.body.appendChild(this.overlay);
              else
                  dom.DomHandler.appendChild(this.overlay, this.appendTo);
              if (!this.overlay.style.minWidth) {
                  this.overlay.style.minWidth = dom.DomHandler.getWidth(this.el.nativeElement.children[0]) + 'px';
              }
          }
      };
      AutoComplete.prototype.resolveFieldData = function (value) {
          return this.field ? utils.ObjectUtils.resolveFieldData(value, this.field) : value;
      };
      AutoComplete.prototype.restoreOverlayAppend = function () {
          if (this.overlay && this.appendTo) {
              this.el.nativeElement.appendChild(this.overlay);
          }
      };
      AutoComplete.prototype.alignOverlay = function () {
          if (this.appendTo)
              dom.DomHandler.absolutePosition(this.overlay, (this.multiple ? this.multiContainerEL.nativeElement : this.inputEL.nativeElement));
          else
              dom.DomHandler.relativePosition(this.overlay, (this.multiple ? this.multiContainerEL.nativeElement : this.inputEL.nativeElement));
      };
      AutoComplete.prototype.hide = function () {
          this.overlayVisible = false;
      };
      AutoComplete.prototype.handleDropdownClick = function (event) {
          if (!this.overlayVisible) {
              this.focusInput();
              var queryValue = this.multiple ? this.multiInputEL.nativeElement.value : this.inputEL.nativeElement.value;
              if (this.dropdownMode === 'blank')
                  this.search(event, '');
              else if (this.dropdownMode === 'current')
                  this.search(event, queryValue);
                  this.loading = true;
              this.onDropdownClick.emit({
                  originalEvent: event,
                  query: queryValue
              });
          }
          else {
              this.hide();
          }
      };
      AutoComplete.prototype.focusInput = function () {
          if (this.multiple)
              this.multiInputEL.nativeElement.focus();
          else
              this.inputEL.nativeElement.focus();
      };
      AutoComplete.prototype.removeItem = function (item) {
          var itemIndex = dom.DomHandler.index(item);
          var removedValue = this.value[itemIndex];
          this.value = this.value.filter(function (val, i) { return i != itemIndex; });
          this.onModelChange(this.value);
          this.updateFilledState();
          this.onUnselect.emit(removedValue);
      };
      AutoComplete.prototype.onKeydown = function (event) {
          if (this.overlayVisible) {
              var highlightItemIndex = this.findOptionIndex(this.highlightOption);
              switch (event.which) {
                  //down
                  case 40:
                      if (highlightItemIndex != -1) {
                          var nextItemIndex = highlightItemIndex + 1;
                          if (nextItemIndex != (this.suggestions.length)) {
                              this.highlightOption = this.suggestions[nextItemIndex];
                              this.highlightOptionChanged = true;
                          }
                      }
                      else {
                          this.highlightOption = this.suggestions[0];
                      }
                      event.preventDefault();
                      break;
                  //up
                  case 38:
                      if (highlightItemIndex > 0) {
                          var prevItemIndex = highlightItemIndex - 1;
                          this.highlightOption = this.suggestions[prevItemIndex];
                          this.highlightOptionChanged = true;
                      }
                      event.preventDefault();
                      break;
                  //enter
                  case 13:
                      if (this.highlightOption) {
                          this.selectItem(this.highlightOption);
                          this.hide();
                      }
                      event.preventDefault();
                      break;
                  //escape
                  case 27:
                      this.hide();
                      event.preventDefault();
                      break;
                  //tab
                  case 9:
                      if (this.highlightOption) {
                          this.selectItem(this.highlightOption);
                      }
                      this.hide();
                      break;
              }
          }
          else {
              if (event.which === 40 && this.suggestions) {
                  this.search(event, event.target.value);
              }
          }
          if (this.multiple) {
              switch (event.which) {
                  //backspace
                  case 8:
                      if (this.value && this.value.length && !this.multiInputEL.nativeElement.value) {
                          this.value = __spread(this.value);
                          var removedValue = this.value.pop();
                          this.onModelChange(this.value);
                          this.updateFilledState();
                          this.onUnselect.emit(removedValue);
                      }
                      break;
              }
          }
          this.inputKeyDown = true;
      };
      AutoComplete.prototype.onKeyup = function (event) {
          this.onKeyUp.emit(event);
      };
      AutoComplete.prototype.onInputFocus = function (event) {
          if (!this.itemClicked && this.completeOnFocus) {
              var queryValue = this.multiple ? this.multiInputEL.nativeElement.value : this.inputEL.nativeElement.value;
              this.search(event, queryValue);
          }
          this.focus = true;
          this.onFocus.emit(event);
          this.itemClicked = false;
      };
      AutoComplete.prototype.onInputBlur = function (event) {
          this.focus = false;
          this.onModelTouched();
          this.onBlur.emit(event);
      };
      AutoComplete.prototype.onInputChange = function (event) {
          var e_1, _a;
          var _this = this;
          if (this.forceSelection) {
              var valid = false;
              var inputValue = event.target.value.trim();
              if (this.suggestions) {
                  var _loop_1 = function (suggestion) {
                      var itemValue = this_1.field ? utils.ObjectUtils.resolveFieldData(suggestion, this_1.field) : suggestion;
                      if (itemValue && inputValue === itemValue.trim()) {
                          valid = true;
                          this_1.forceSelectionUpdateModelTimeout = setTimeout(function () {
                              _this.selectItem(suggestion, false);
                          }, 250);
                          return "break";
                      }
                  };
                  var this_1 = this;
                  try {
                      for (var _b = __values(this.suggestions), _c = _b.next(); !_c.done; _c = _b.next()) {
                          var suggestion = _c.value;
                          var state_1 = _loop_1(suggestion);
                          if (state_1 === "break")
                              break;
                      }
                  }
                  catch (e_1_1) { e_1 = { error: e_1_1 }; }
                  finally {
                      try {
                          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                      }
                      finally { if (e_1) throw e_1.error; }
                  }
              }
              if (!valid) {
                  if (this.multiple) {
                      this.multiInputEL.nativeElement.value = '';
                  }
                  else {
                      this.value = null;
                      this.inputEL.nativeElement.value = '';
                  }
                  this.onClear.emit(event);
                  this.onModelChange(this.value);
              }
          }
      };
      AutoComplete.prototype.onInputPaste = function (event) {
          this.onKeydown(event);
      };
      AutoComplete.prototype.isSelected = function (val) {
          var selected = false;
          if (this.value && this.value.length) {
              for (var i = 0; i < this.value.length; i++) {
                  if (utils.ObjectUtils.equals(this.value[i], val, this.dataKey)) {
                      selected = true;
                      break;
                  }
              }
          }
          return selected;
      };
      AutoComplete.prototype.findOptionIndex = function (option) {
          var index = -1;
          if (this.suggestions) {
              for (var i = 0; i < this.suggestions.length; i++) {
                  if (utils.ObjectUtils.equals(option, this.suggestions[i])) {
                      index = i;
                      break;
                  }
              }
          }
          return index;
      };
      AutoComplete.prototype.updateFilledState = function () {
          if (this.multiple)
              this.filled = (this.value && this.value.length) || (this.multiInputEL && this.multiInputEL.nativeElement && this.multiInputEL.nativeElement.value != '');
          else
              this.filled = (this.inputFieldValue && this.inputFieldValue != '') || (this.inputEL && this.inputEL.nativeElement && this.inputEL.nativeElement.value != '');
          ;
      };
      AutoComplete.prototype.updateInputField = function () {
          var formattedValue = this.value ? (this.field ? utils.ObjectUtils.resolveFieldData(this.value, this.field) || '' : this.value) : '';
          this.inputFieldValue = formattedValue;
          if (this.inputEL && this.inputEL.nativeElement) {
              this.inputEL.nativeElement.value = formattedValue;
          }
          this.updateFilledState();
      };
      AutoComplete.prototype.bindDocumentClickListener = function () {
          var _this = this;
          if (!this.documentClickListener) {
              this.documentClickListener = this.renderer.listen('document', 'click', function (event) {
                  if (event.which === 3) {
                      return;
                  }
                  if (!_this.inputClick && !_this.isDropdownClick(event)) {
                      _this.hide();
                  }
                  _this.inputClick = false;
                  _this.cd.markForCheck();
              });
          }
      };
      AutoComplete.prototype.isDropdownClick = function (event) {
          if (this.dropdown) {
              var target = event.target;
              return (target === this.dropdownButton.nativeElement || target.parentNode === this.dropdownButton.nativeElement);
          }
          else {
              return false;
          }
      };
      AutoComplete.prototype.unbindDocumentClickListener = function () {
          if (this.documentClickListener) {
              this.documentClickListener();
              this.documentClickListener = null;
          }
      };
      AutoComplete.prototype.bindDocumentResizeListener = function () {
          this.documentResizeListener = this.onWindowResize.bind(this);
          window.addEventListener('resize', this.documentResizeListener);
      };
      AutoComplete.prototype.unbindDocumentResizeListener = function () {
          if (this.documentResizeListener) {
              window.removeEventListener('resize', this.documentResizeListener);
              this.documentResizeListener = null;
          }
      };
      AutoComplete.prototype.onWindowResize = function () {
          this.hide();
      };
      AutoComplete.prototype.onOverlayHide = function () {
          this.unbindDocumentClickListener();
          this.unbindDocumentResizeListener();
          this.overlay = null;
          this.onHide.emit();
      };
      AutoComplete.prototype.ngOnDestroy = function () {
          if (this.forceSelectionUpdateModelTimeout) {
              clearTimeout(this.forceSelectionUpdateModelTimeout);
              this.forceSelectionUpdateModelTimeout = null;
          }
          this.restoreOverlayAppend();
          this.onOverlayHide();
      };
      AutoComplete.ctorParameters = function () { return [
          { type: core.ElementRef },
          { type: core.Renderer2 },
          { type: core.ChangeDetectorRef },
          { type: core.IterableDiffers }
      ]; };
      __decorate([
          core.Input()
      ], AutoComplete.prototype, "minLength", void 0);
      __decorate([
          core.Input()
      ], AutoComplete.prototype, "delay", void 0);
      __decorate([
          core.Input()
      ], AutoComplete.prototype, "style", void 0);
      __decorate([
          core.Input()
      ], AutoComplete.prototype, "panelStyle", void 0);
      __decorate([
          core.Input()
      ], AutoComplete.prototype, "styleClass", void 0);
      __decorate([
          core.Input()
      ], AutoComplete.prototype, "panelStyleClass", void 0);
      __decorate([
          core.Input()
      ], AutoComplete.prototype, "inputStyle", void 0);
      __decorate([
          core.Input()
      ], AutoComplete.prototype, "inputId", void 0);
      __decorate([
          core.Input()
      ], AutoComplete.prototype, "inputStyleClass", void 0);
      __decorate([
          core.Input()
      ], AutoComplete.prototype, "placeholder", void 0);
      __decorate([
          core.Input()
      ], AutoComplete.prototype, "readonly", void 0);
      __decorate([
          core.Input()
      ], AutoComplete.prototype, "disabled", void 0);
      __decorate([
          core.Input()
      ], AutoComplete.prototype, "maxlength", void 0);
      __decorate([
          core.Input()
      ], AutoComplete.prototype, "name", void 0);
      __decorate([
          core.Input()
      ], AutoComplete.prototype, "required", void 0);
      __decorate([
          core.Input()
      ], AutoComplete.prototype, "size", void 0);
      __decorate([
          core.Input()
      ], AutoComplete.prototype, "appendTo", void 0);
      __decorate([
          core.Input()
      ], AutoComplete.prototype, "autoHighlight", void 0);
      __decorate([
          core.Input()
      ], AutoComplete.prototype, "forceSelection", void 0);
      __decorate([
          core.Input()
      ], AutoComplete.prototype, "type", void 0);
      __decorate([
          core.Input()
      ], AutoComplete.prototype, "autoZIndex", void 0);
      __decorate([
          core.Input()
      ], AutoComplete.prototype, "baseZIndex", void 0);
      __decorate([
          core.Input()
      ], AutoComplete.prototype, "ariaLabel", void 0);
      __decorate([
          core.Input()
      ], AutoComplete.prototype, "ariaLabelledBy", void 0);
      __decorate([
          core.Input()
      ], AutoComplete.prototype, "dropdownIcon", void 0);
      __decorate([
          core.Input()
      ], AutoComplete.prototype, "unique", void 0);
      __decorate([
          core.Input()
      ], AutoComplete.prototype, "completeOnFocus", void 0);
      __decorate([
          core.Output()
      ], AutoComplete.prototype, "completeMethod", void 0);
      __decorate([
          core.Output()
      ], AutoComplete.prototype, "onSelect", void 0);
      __decorate([
          core.Output()
      ], AutoComplete.prototype, "onUnselect", void 0);
      __decorate([
          core.Output()
      ], AutoComplete.prototype, "onFocus", void 0);
      __decorate([
          core.Output()
      ], AutoComplete.prototype, "onBlur", void 0);
      __decorate([
          core.Output()
      ], AutoComplete.prototype, "onDropdownClick", void 0);
      __decorate([
          core.Output()
      ], AutoComplete.prototype, "onClear", void 0);
      __decorate([
          core.Output()
      ], AutoComplete.prototype, "onKeyUp", void 0);
      __decorate([
          core.Output()
      ], AutoComplete.prototype, "onShow", void 0);
      __decorate([
          core.Output()
      ], AutoComplete.prototype, "onHide", void 0);
      __decorate([
          core.Input()
      ], AutoComplete.prototype, "field", void 0);
      __decorate([
          core.Input()
      ], AutoComplete.prototype, "scrollHeight", void 0);
      __decorate([
          core.Input()
      ], AutoComplete.prototype, "dropdown", void 0);
      __decorate([
          core.Input()
      ], AutoComplete.prototype, "dropdownMode", void 0);
      __decorate([
          core.Input()
      ], AutoComplete.prototype, "multiple", void 0);
      __decorate([
          core.Input()
      ], AutoComplete.prototype, "tabindex", void 0);
      __decorate([
          core.Input()
      ], AutoComplete.prototype, "dataKey", void 0);
      __decorate([
          core.Input()
      ], AutoComplete.prototype, "emptyMessage", void 0);
      __decorate([
          core.Input()
      ], AutoComplete.prototype, "showTransitionOptions", void 0);
      __decorate([
          core.Input()
      ], AutoComplete.prototype, "hideTransitionOptions", void 0);
      __decorate([
          core.Input()
      ], AutoComplete.prototype, "autofocus", void 0);
      __decorate([
          core.Input()
      ], AutoComplete.prototype, "autocomplete", void 0);
      __decorate([
          core.ViewChild('in')
      ], AutoComplete.prototype, "inputEL", void 0);
      __decorate([
          core.ViewChild('multiIn')
      ], AutoComplete.prototype, "multiInputEL", void 0);
      __decorate([
          core.ViewChild('multiContainer')
      ], AutoComplete.prototype, "multiContainerEL", void 0);
      __decorate([
          core.ViewChild('ddBtn')
      ], AutoComplete.prototype, "dropdownButton", void 0);
      __decorate([
          core.ContentChildren(api.PrimeTemplate)
      ], AutoComplete.prototype, "templates", void 0);
      __decorate([
          core.Input()
      ], AutoComplete.prototype, "suggestions", null);
AutoComplete.ɵfac = function AutoComplete_Factory(t) { return new (t || AutoComplete)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.IterableDiffers)); };
AutoComplete.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AutoComplete, selectors: [["p-autoComplete"]], contentQueries: function AutoComplete_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, api.PrimeTemplate, 4);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.templates = _t);
    } }, viewQuery: function AutoComplete_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 5);
        ɵngcc0.ɵɵviewQuery(_c1, 5);
        ɵngcc0.ɵɵviewQuery(_c2, 5);
        ɵngcc0.ɵɵviewQuery(_c3, 5);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.inputEL = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.multiInputEL = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.multiContainerEL = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dropdownButton = _t.first);
    } }, hostVars: 4, hostBindings: function AutoComplete_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("ui-inputwrapper-filled", ctx.filled)("ui-inputwrapper-focus", ctx.focus && !ctx.disabled);
    } }, inputs: { minLength: "minLength", delay: "delay", type: "type", autoZIndex: "autoZIndex", baseZIndex: "baseZIndex", dropdownIcon: "dropdownIcon", unique: "unique", completeOnFocus: "completeOnFocus", scrollHeight: "scrollHeight", dropdownMode: "dropdownMode", showTransitionOptions: "showTransitionOptions", hideTransitionOptions: "hideTransitionOptions", autocomplete: "autocomplete", suggestions: "suggestions", disabled: "disabled", style: "style", panelStyle: "panelStyle", styleClass: "styleClass", panelStyleClass: "panelStyleClass", inputStyle: "inputStyle", inputId: "inputId", inputStyleClass: "inputStyleClass", placeholder: "placeholder", readonly: "readonly", maxlength: "maxlength", name: "name", required: "required", size: "size", appendTo: "appendTo", autoHighlight: "autoHighlight", forceSelection: "forceSelection", ariaLabel: "ariaLabel", ariaLabelledBy: "ariaLabelledBy", field: "field", dropdown: "dropdown", multiple: "multiple", tabindex: "tabindex", dataKey: "dataKey", emptyMessage: "emptyMessage", autofocus: "autofocus" }, outputs: { completeMethod: "completeMethod", onSelect: "onSelect", onUnselect: "onUnselect", onFocus: "onFocus", onBlur: "onBlur", onDropdownClick: "onDropdownClick", onClear: "onClear", onKeyUp: "onKeyUp", onShow: "onShow", onHide: "onHide" }, features: [ɵngcc0.ɵɵProvidersFeature([AUTOCOMPLETE_VALUE_ACCESSOR])], decls: 6, vars: 12, consts: [[3, "ngClass", "ngStyle"], ["aria-autocomplete", "list", "role", "searchbox", "aria-haspopup", "true", 3, "ngStyle", "class", "autocomplete", "ngClass", "value", "readonly", "disabled", "click", "input", "keydown", "keyup", "focus", "blur", "change", "paste", 4, "ngIf"], ["class", "ui-autocomplete-multiple-container ui-widget ui-inputtext ui-state-default ui-corner-all", 3, "ngClass", "click", 4, "ngIf"], ["class", "ui-autocomplete-loader pi pi-spinner pi-spin", 4, "ngIf"], ["type", "button", "pButton", "", "class", "ui-autocomplete-dropdown", 3, "icon", "disabled", "click", 4, "ngIf"], [3, "ngClass", "max-height", "ngStyle", "class", 4, "ngIf"], ["aria-autocomplete", "list", "role", "searchbox", "aria-haspopup", "true", 3, "ngStyle", "autocomplete", "ngClass", "value", "readonly", "disabled", "click", "input", "keydown", "keyup", "focus", "blur", "change", "paste"], ["in", ""], [1, "ui-autocomplete-multiple-container", "ui-widget", "ui-inputtext", "ui-state-default", "ui-corner-all", 3, "ngClass", "click"], ["multiContainer", ""], ["class", "ui-autocomplete-token ui-state-highlight ui-corner-all", 4, "ngFor", "ngForOf"], [1, "ui-autocomplete-input-token"], ["aria-autocomplete", "list", "role", "searchbox", "aria-haspopup", "true", 3, "disabled", "readonly", "autocomplete", "ngStyle", "input", "click", "keydown", "keyup", "focus", "blur", "change", "paste"], ["multiIn", ""], [1, "ui-autocomplete-token", "ui-state-highlight", "ui-corner-all"], ["token", ""], ["class", "ui-autocomplete-token-icon pi pi-fw pi-times", 3, "click", 4, "ngIf"], ["class", "ui-autocomplete-token-label", 4, "ngIf"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "ui-autocomplete-token-icon", "pi", "pi-fw", "pi-times", 3, "click"], [1, "ui-autocomplete-token-label"], [1, "ui-autocomplete-loader", "pi", "pi-spinner", "pi-spin"], ["type", "button", "pButton", "", 1, "ui-autocomplete-dropdown", 3, "icon", "disabled", "click"], ["ddBtn", ""], ["panel", ""], ["role", "listbox", 1, "ui-autocomplete-items", "ui-autocomplete-list", "ui-widget-content", "ui-widget", "ui-corner-all", "ui-helper-reset"], ["role", "option", 3, "ngClass", "id", "mouseenter", "mouseleave", "click", 4, "ngFor", "ngForOf"], ["class", "ui-autocomplete-emptymessage ui-autocomplete-list-item ui-corner-all", 4, "ngIf"], ["role", "option", 3, "ngClass", "id", "mouseenter", "mouseleave", "click"], [4, "ngIf"], [1, "ui-autocomplete-emptymessage", "ui-autocomplete-list-item", "ui-corner-all"]], template: function AutoComplete_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "span", 0);
        ɵngcc0.ɵɵtemplate(1, AutoComplete_input_1_Template, 2, 23, "input", 1);
        ɵngcc0.ɵɵtemplate(2, AutoComplete_ul_2_Template, 6, 23, "ul", 2);
        ɵngcc0.ɵɵtemplate(3, AutoComplete_i_3_Template, 1, 0, "i", 3);
        ɵngcc0.ɵɵtemplate(4, AutoComplete_button_4_Template, 2, 3, "button", 4);
        ɵngcc0.ɵɵtemplate(5, AutoComplete_div_5_Template, 5, 16, "div", 5);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.styleClass);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(9, _c12, ctx.dropdown, ctx.multiple))("ngStyle", ctx.style);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.multiple);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.multiple);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.loading);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.dropdown);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.overlayVisible);
    } }, directives: [ɵngcc1.NgClass, ɵngcc1.NgStyle, ɵngcc1.NgIf, ɵngcc1.NgForOf, ɵngcc1.NgTemplateOutlet, ɵngcc2.ButtonDirective], encapsulation: 2, data: { animation: [
            animations.trigger('overlayAnimation', [
                animations.state('void', animations.style({
                    transform: 'translateY(5%)',
                    opacity: 0
                })),
                animations.state('visible', animations.style({
                    transform: 'translateY(0)',
                    opacity: 1
                })),
                animations.transition('void => visible', animations.animate('{{showTransitionParams}}')),
                animations.transition('visible => void', animations.animate('{{hideTransitionParams}}'))
            ])
        ] } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AutoComplete, [{
        type: core.Component,
        args: [{
                selector: 'p-autoComplete',
                template: "\n        <span [ngClass]=\"{'ui-autocomplete ui-widget':true,'ui-autocomplete-dd':dropdown,'ui-autocomplete-multiple':multiple}\" [ngStyle]=\"style\" [class]=\"styleClass\">\n            <input *ngIf=\"!multiple\" #in [attr.type]=\"type\" [attr.id]=\"inputId\" [ngStyle]=\"inputStyle\" [class]=\"inputStyleClass\" [autocomplete]=\"autocomplete\" [attr.required]=\"required\" [attr.name]=\"name\"\n            [ngClass]=\"'ui-inputtext ui-widget ui-state-default ui-corner-all ui-autocomplete-input'\" [value]=\"inputFieldValue\" aria-autocomplete=\"list\" [attr.aria-controls]=\"listId\" role=\"searchbox\" [attr.aria-expanded]=\"overlayVisible\" aria-haspopup=\"true\" [attr.aria-activedescendant]=\"'p-highlighted-option'\"\n            (click)=\"onInputClick($event)\" (input)=\"onInput($event)\" (keydown)=\"onKeydown($event)\" (keyup)=\"onKeyup($event)\" [attr.autofocus]=\"autofocus\" (focus)=\"onInputFocus($event)\" (blur)=\"onInputBlur($event)\" (change)=\"onInputChange($event)\" (paste)=\"onInputPaste($event)\"\n            [attr.placeholder]=\"placeholder\" [attr.size]=\"size\" [attr.maxlength]=\"maxlength\" [attr.tabindex]=\"tabindex\" [readonly]=\"readonly\" [disabled]=\"disabled\" [attr.aria-label]=\"ariaLabel\" [attr.aria-labelledby]=\"ariaLabelledBy\" [attr.aria-required]=\"required\"\n            ><ul *ngIf=\"multiple\" #multiContainer class=\"ui-autocomplete-multiple-container ui-widget ui-inputtext ui-state-default ui-corner-all\" [ngClass]=\"{'ui-state-disabled':disabled,'ui-state-focus':focus}\" (click)=\"multiIn.focus()\">\n                <li #token *ngFor=\"let val of value\" class=\"ui-autocomplete-token ui-state-highlight ui-corner-all\">\n                    <span class=\"ui-autocomplete-token-icon pi pi-fw pi-times\" (click)=\"removeItem(token)\" *ngIf=\"!disabled\"></span>\n                    <span *ngIf=\"!selectedItemTemplate\" class=\"ui-autocomplete-token-label\">{{resolveFieldData(val)}}</span>\n                    <ng-container *ngTemplateOutlet=\"selectedItemTemplate; context: {$implicit: val}\"></ng-container>\n                </li>\n                <li class=\"ui-autocomplete-input-token\">\n                    <input #multiIn [attr.type]=\"type\" [attr.id]=\"inputId\" [disabled]=\"disabled\" [attr.placeholder]=\"(value&&value.length ? null : placeholder)\" [attr.tabindex]=\"tabindex\" [attr.maxlength]=\"maxlength\" (input)=\"onInput($event)\"  (click)=\"onInputClick($event)\"\n                            (keydown)=\"onKeydown($event)\" [readonly]=\"readonly\" (keyup)=\"onKeyup($event)\" [attr.autofocus]=\"autofocus\" (focus)=\"onInputFocus($event)\" (blur)=\"onInputBlur($event)\" (change)=\"onInputChange($event)\" (paste)=\"onInputPaste($event)\" [autocomplete]=\"autocomplete\"\n                            [ngStyle]=\"inputStyle\" [class]=\"inputStyleClass\" [attr.aria-label]=\"ariaLabel\" [attr.aria-labelledby]=\"ariaLabelledBy\" [attr.aria-required]=\"required\"\n                            aria-autocomplete=\"list\" [attr.aria-controls]=\"listId\" role=\"searchbox\" [attr.aria-expanded]=\"overlayVisible\" aria-haspopup=\"true\" [attr.aria-activedescendant]=\"'p-highlighted-option'\">\n                </li>\n            </ul>\n            <i *ngIf=\"loading\" class=\"ui-autocomplete-loader pi pi-spinner pi-spin\"></i><button #ddBtn type=\"button\" pButton [icon]=\"dropdownIcon\" class=\"ui-autocomplete-dropdown\" [disabled]=\"disabled\"\n                (click)=\"handleDropdownClick($event)\" *ngIf=\"dropdown\" [attr.tabindex]=\"tabindex\"></button>\n            <div #panel *ngIf=\"overlayVisible\" [ngClass]=\"['ui-autocomplete-panel ui-widget ui-widget-content ui-corner-all ui-shadow']\" [style.max-height]=\"scrollHeight\" [ngStyle]=\"panelStyle\" [class]=\"panelStyleClass\"\n                [@overlayAnimation]=\"{value: 'visible', params: {showTransitionParams: showTransitionOptions, hideTransitionParams: hideTransitionOptions}}\" (@overlayAnimation.start)=\"onOverlayAnimationStart($event)\" (@overlayAnimation.done)=\"onOverlayAnimationDone($event)\" >\n                <ul role=\"listbox\" [attr.id]=\"listId\" class=\"ui-autocomplete-items ui-autocomplete-list ui-widget-content ui-widget ui-corner-all ui-helper-reset\">\n                    <li role=\"option\"  *ngFor=\"let option of suggestions; let idx = index\" [ngClass]=\"{'ui-autocomplete-list-item ui-corner-all':true,'ui-state-highlight':(highlightOption==option)}\"\n                        (mouseenter)=\"highlightOption=option\" (mouseleave)=\"highlightOption=null\" [id]=\"highlightOption == option ? 'p-highlighted-option':''\" (click)=\"selectItem(option)\">\n                        <span *ngIf=\"!itemTemplate\">{{resolveFieldData(option)}}</span>\n                        <ng-container *ngTemplateOutlet=\"itemTemplate; context: {$implicit: option, index: idx}\"></ng-container>\n                    </li>\n                    <li *ngIf=\"noResults && emptyMessage\" class=\"ui-autocomplete-emptymessage ui-autocomplete-list-item ui-corner-all\">{{emptyMessage}}</li>\n                </ul>\n            </div>\n        </span>\n    ",
                animations: [
                    animations.trigger('overlayAnimation', [
                        animations.state('void', animations.style({
                            transform: 'translateY(5%)',
                            opacity: 0
                        })),
                        animations.state('visible', animations.style({
                            transform: 'translateY(0)',
                            opacity: 1
                        })),
                        animations.transition('void => visible', animations.animate('{{showTransitionParams}}')),
                        animations.transition('visible => void', animations.animate('{{hideTransitionParams}}'))
                    ])
                ],
                host: {
                    '[class.ui-inputwrapper-filled]': 'filled',
                    '[class.ui-inputwrapper-focus]': 'focus && !disabled'
                },
                providers: [AUTOCOMPLETE_VALUE_ACCESSOR],
                changeDetection: core.ChangeDetectionStrategy.Default
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.IterableDiffers }]; }, { minLength: [{
            type: core.Input
        }], delay: [{
            type: core.Input
        }], type: [{
            type: core.Input
        }], autoZIndex: [{
            type: core.Input
        }], baseZIndex: [{
            type: core.Input
        }], dropdownIcon: [{
            type: core.Input
        }], unique: [{
            type: core.Input
        }], completeOnFocus: [{
            type: core.Input
        }], completeMethod: [{
            type: core.Output
        }], onSelect: [{
            type: core.Output
        }], onUnselect: [{
            type: core.Output
        }], onFocus: [{
            type: core.Output
        }], onBlur: [{
            type: core.Output
        }], onDropdownClick: [{
            type: core.Output
        }], onClear: [{
            type: core.Output
        }], onKeyUp: [{
            type: core.Output
        }], onShow: [{
            type: core.Output
        }], onHide: [{
            type: core.Output
        }], scrollHeight: [{
            type: core.Input
        }], dropdownMode: [{
            type: core.Input
        }], showTransitionOptions: [{
            type: core.Input
        }], hideTransitionOptions: [{
            type: core.Input
        }], autocomplete: [{
            type: core.Input
        }], suggestions: [{
            type: core.Input
        }], disabled: [{
            type: core.Input
        }], style: [{
            type: core.Input
        }], panelStyle: [{
            type: core.Input
        }], styleClass: [{
            type: core.Input
        }], panelStyleClass: [{
            type: core.Input
        }], inputStyle: [{
            type: core.Input
        }], inputId: [{
            type: core.Input
        }], inputStyleClass: [{
            type: core.Input
        }], placeholder: [{
            type: core.Input
        }], readonly: [{
            type: core.Input
        }], maxlength: [{
            type: core.Input
        }], name: [{
            type: core.Input
        }], required: [{
            type: core.Input
        }], size: [{
            type: core.Input
        }], appendTo: [{
            type: core.Input
        }], autoHighlight: [{
            type: core.Input
        }], forceSelection: [{
            type: core.Input
        }], ariaLabel: [{
            type: core.Input
        }], ariaLabelledBy: [{
            type: core.Input
        }], field: [{
            type: core.Input
        }], dropdown: [{
            type: core.Input
        }], multiple: [{
            type: core.Input
        }], tabindex: [{
            type: core.Input
        }], dataKey: [{
            type: core.Input
        }], emptyMessage: [{
            type: core.Input
        }], autofocus: [{
            type: core.Input
        }], inputEL: [{
            type: core.ViewChild,
            args: ['in']
        }], multiInputEL: [{
            type: core.ViewChild,
            args: ['multiIn']
        }], multiContainerEL: [{
            type: core.ViewChild,
            args: ['multiContainer']
        }], dropdownButton: [{
            type: core.ViewChild,
            args: ['ddBtn']
        }], templates: [{
            type: core.ContentChildren,
            args: [api.PrimeTemplate]
        }] }); })();
      return AutoComplete;
  }());
  var AutoCompleteModule = /** @class */ (function () {
      function AutoCompleteModule() {
      }
AutoCompleteModule.ɵfac = function AutoCompleteModule_Factory(t) { return new (t || AutoCompleteModule)(); };
AutoCompleteModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: AutoCompleteModule });
AutoCompleteModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[common.CommonModule, inputtext.InputTextModule, button.ButtonModule, api.SharedModule], ɵngcc3.SharedModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AutoCompleteModule, [{
        type: core.NgModule,
        args: [{
                imports: [common.CommonModule, inputtext.InputTextModule, button.ButtonModule, api.SharedModule],
                exports: [AutoComplete, api.SharedModule],
                declarations: [AutoComplete]
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AutoCompleteModule, { declarations: [AutoComplete], imports: [ɵngcc1.CommonModule, ɵngcc4.InputTextModule, ɵngcc2.ButtonModule, ɵngcc3.SharedModule], exports: [AutoComplete, ɵngcc3.SharedModule] }); })();
      return AutoCompleteModule;
  }());

  exports.AUTOCOMPLETE_VALUE_ACCESSOR = AUTOCOMPLETE_VALUE_ACCESSOR;
  exports.AutoComplete = AutoComplete;
  exports.AutoCompleteModule = AutoCompleteModule;

  Object.defineProperty(exports, '__esModule', { value: true });

})));

